import { WarrantyExtensionType } from '../Enums/warrantyExtensionType';

export class WarrantyInfo {
    id: number;
    type: WarrantyExtensionType;
    data: string;
    startDate: Date;
    endDate: Date;
}